import * as channelRoutines from '../channelRoutines';
import * as channelSelectors from '../channelsSelectors';
import * as paths from '../../../Providers/paths';
import * as rootSelectors from '../../../selectors/root';
import * as toastRoutines from '../../../sagas/routines/toastRoutines';
import * as userRoutines from '../../../sagas/routines/userRoutines';
import { call, put, select } from 'redux-saga/effects';
import { clearActiveChannel } from '../../../redux/ui/actions';
import { deleteFileFromStorageSaga } from '../../../sagas/filesSaga';
import { extractFileTypeFromBase64 } from '../../../helpers/fileTypeRegex';
import { makeDistinctUsersFromCombinedSaga } from '../../../sagas/users';
import { push } from 'connected-react-router';
import { rsf } from '../../../globals/firebase';
import { sendStringSaga } from '../../../sagas/filesSaga';
export function* createNewChannel(action) {
    try {
        const activeEvent = yield select(rootSelectors.selectActiveEventId);
        const { fileSelected, imageURL, name, whitelist } = action.payload;
        const isNameHidden = action.payload.isNameHidden === true ? true : false;

        const channel = yield call(rsf.database.create, paths.moduleConfig(activeEvent, 'inbox', 'chat', 'channels'), {
            index: 0,
        });
        const channels = yield select(rootSelectors.selectChannels);
        const channelCount = Object.keys(channels).length;
        //Preps object to match schema
        let optimizedWhitelist = {};
        //TODO move this to a helper
        whitelist.map(obj => {
            optimizedWhitelist[obj.id] = obj.name;
            return obj;
        });

        let target = {
            index: channelCount,
            name,
            imageURL,
            isNameHidden,
            whitelist: optimizedWhitelist,
        };

        //If user has selected an image to be uploaded
        if (fileSelected) {
            try {
                const activeEvent = yield select(rootSelectors.selectActiveEventId);
                const fileType = extractFileTypeFromBase64(target.imageURL);
                const filePath = paths.storage_channel(activeEvent, channel) + `background.${fileType}`;

                const downloadablePath = yield call(sendStringSaga, { filePath, imageURL: target.imageURL });
                target = {
                    ...target,
                    imageURL: downloadablePath,
                };
            } catch (error) {}
        }

        yield call(rsf.database.update, paths.moduleConfig(activeEvent, 'inbox', 'chat', 'channels', channel), target);
        yield put(push(`/events/${activeEvent}/channels`));
        yield put(clearActiveChannel());
        yield put(toastRoutines.setToastSuccess('New channel created!'));
        yield put(channelRoutines.createChannel.success());
        yield put(userRoutines.clearExtractedUsers.trigger());
    } catch (error) {
        yield put(channelRoutines.createChannel.failure(error));
    }
}

export function* updateChannel(action) {
    const whitelist = yield call(makeDistinctUsersFromCombinedSaga, { payload: action.payload.whitelist });
    const isNameHidden = action.payload.isNameHidden === true ? true : false;

    //Preps object to match schema
    let optimizedWhitelist = {};
    whitelist.map(obj => {
        optimizedWhitelist[obj.id] = obj.name;
        return obj;
    });

    try {
        const activeEvent = yield select(rootSelectors.selectActiveEventId);
        const activeChannel = yield select(rootSelectors.selectActiveChannelId);

        let target = { ...action.payload, whitelist: optimizedWhitelist, isNameHidden };
        //If user has selected an image to be uploaded
        if (target.fileSelected) {
            const fileType = extractFileTypeFromBase64(target.imageURL);

            const activeChannelBackground = yield select(channelSelectors.makeActiveChannelBackground);
            //Let's try to delete current background image before updating with a new one
            if (activeChannelBackground)
                yield call(
                    deleteFileFromStorageSaga,
                    activeChannelBackground,
                    paths.storage_channel(activeEvent, activeChannel),
                );
            const filePath = paths.storage_channel(activeEvent, activeChannel) + `background.${fileType}`;
            try {
                const downloadablePath = yield call(sendStringSaga, { filePath, imageURL: target.imageURL });
                target = {
                    ...target,
                    imageURL: downloadablePath,
                };
            } catch (error) {}
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { fileSelected, ...payload } = target;
        yield call(
            rsf.database.patch,
            paths.moduleConfig(activeEvent, 'inbox', 'chat', 'channels', activeChannel),
            payload,
        );

        yield put(push(`/events/${activeEvent}/channels`));
        yield put(userRoutines.clearExtractedUsers.trigger());
        yield put(toastRoutines.setToastSuccess('Channel updated!'));

        yield put(clearActiveChannel());
    } catch (error) {
        yield put(channelRoutines.createChannel.failure(error));
    }
}

export function* removeChannel(action) {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    const channels = yield select(rootSelectors.selectChannels);
    const currentChannelBackground = channels[action.payload] ? channels[action.payload].imageURL : null;
    try {
        if (currentChannelBackground)
            yield call(
                deleteFileFromStorageSaga,
                currentChannelBackground,
                paths.storage_channel(activeEvent, action.payload),
            );
        yield call(rsf.database.delete, paths.moduleConfig(activeEvent, 'inbox', 'chat', 'channels', action.payload));
        yield put(toastRoutines.setToastSuccess('Channel removed!'));
        yield put(channelRoutines.removeChannel.success());
    } catch (error) {
        yield put(channelRoutines.removeChannel.failure(error));
    }
}

export function* updateChannelOrder(action) {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    let { id, index } = action.payload;
    try {
        yield call(rsf.database.patch, paths.moduleConfig(activeEvent, 'inbox', 'chat', 'channels', id), { index });
        put(channelRoutines.reorderChannels.success());
    } catch (error) {
        put(channelRoutines.reorderChannels.failure(error));
    }
}
